import React from 'react';

function hasMultiCobrands() {
	return JSON.parse(localStorage.getItem('userData')).cobrands.length > 1;
}

export default hasMultiCobrands;